const SEO = [
	{
		page: "about",
		description:
		"I am a Front-end developer with expertise in React-native and React.Js. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies.",
		keywords: ["Hassan", "Hassan K", "Hassan Khalid"],
	},

	{
		page: "hobbies",
		description:
		"I am a Front-end developer with expertise in React-native and React.Js. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies.",
		keywords: ["Hassan", "Hassan K", "Hassan Khalid"],
	},

	{
		page: "projects",
		description:
		"I am a Front-end developer with expertise in React-native and React.Js. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies.",
		keywords: ["Hassan", "Hassan K", "Hassan Khalid"],
	},

	{
		page: "uses",
		description:
		"I am a Front-end developer with expertise in React-native and React.Js. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies.",
		keywords: ["Hassan", "Hassan K", "Hassan Khalid"],
	},
];

export default SEO;
